import { getSearchParam } from "@/utils";
import { getInitData } from "./utils/getInitData";

// const parsedData =
//   isJSONString(window.indexPageInitDataFromServer) && isEnableParse(window.indexPageInitDataFromServer)
//     ? JSON.parse(window.indexPageInitDataFromServer)
//     : null;
// const locApiAll = LocalStorage.getItem("API_ALL");
// const initInfo = parsedData?.data ?? locApiAll;
// if (!isEmptyType(initInfo) && initInfo.baseInfo) {
//   initInfo.info = initInfo?.info ?? initInfo?.baseInfo ?? {};
//   delete initInfo.baseInfo;
// }
const initData = getInitData();
// 内部原子：存储请求参数和结果
const keyId = getSearchParam("keyId");
const keyAid = getSearchParam("keyAid");
const keyBid = getSearchParam("keyBid");
const keyCid = getSearchParam("keyCid");
const keyDid = getSearchParam("keyDid");
const _latitude = getSearchParam("latitude");
const _longitude = getSearchParam("longitude");
const commonStateAtom = atom<any>({
  params: {
    keyId,
    keyAid,
    keyBid,
    keyCid,
    keyDid,
  },
  data: initData,
  loading: false,
  error: null,
});
/** 与 commonStateAtom 初始 data.f 一致，供其它 atom 默认值使用 */
export const initialDataSource =
  initData != null && typeof initData === "object" ? String((initData as { f?: unknown }).f ?? "") : "";
const pathnameAtom = atom<string>("/");

export { commonStateAtom, keyId, keyAid, keyBid, keyCid, keyDid, _latitude, _longitude, pathnameAtom };
